import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export type SelectingType = "source" | "destination";
export type ClearModeType = "source" | "destination" | "";
export type ColorStepType = 1 | 2 | 3 | 4 | 5;

interface IState {
  visible: boolean;
  zoneLayer: number;
  stationLayer: number;
  pathLayer: number;
  survayLayer: number;
}

const initialState: IState = {
  visible: false,
  zoneLayer: 14,
  stationLayer: 13,
  pathLayer: 12,
  survayLayer: 11,
};

export const layerControlSlice = createSlice({
  name: "layers",
  initialState,
  reducers: {
    changeLayer: (state, action: PayloadAction<object>) => {
      return { ...state, ...action.payload };
    },
    toggleVisibility: (state) => {
      return { ...state, visible: !state.visible };
    },
    makeInvisible: (state) => {
      return { ...state, visible: false };
    },
  },
});

export const { changeLayer, toggleVisibility, makeInvisible } = layerControlSlice.actions;

export default layerControlSlice.reducer;
